import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { UI_OPERATION_STATUS_REQUEST } from '@uncinc/react-drupal-core';

import useOperationStatus from '../../../hooks/useOperationStatus';
import useTypedDispatch from '../../../hooks/useTypedDispatch';
import { commentAnonymize } from '../../../store/actions/Entity/Comment';
import usePopup from '../../../hooks/usePopup';
import useRefreshTrigger from '../../SearchForumThread/hooks/useRefreshTrigger';
import DeleteCommentButtonPopup from './Popup';

import './style.scss';

export interface DeleteCommentProps {
  commentId: number;
}

const DeleteComment: React.FC<DeleteCommentProps> = ({ commentId }) => {
  const { t } = useTranslation();
  const dispatch = useTypedDispatch();

  const operationStatus = useOperationStatus('comment', 'anonymize');

  const popup = usePopup('DeleteCommentPopup', {
    closeOnOutsideClick: true,
  });

  const { triggerSearchRefresh } = useRefreshTrigger();

  const onSubmit = async () => {
    try {
      await dispatch(commentAnonymize(commentId));
      popup.close();

      triggerSearchRefresh();
    } catch (e) {
      // Ignore for now.
    }
  };

  return (
    <div className="DeleteComment">
      <button
        type="button"
        className="icon-before icon-trashcan"
        onClick={() => {
          popup.open();
        }}
      >
        {t('common:pages.forum.delete_comment.button')}
      </button>

      {popup.isOpen && (ReactDOM.createPortal(
        <DeleteCommentButtonPopup
          isLoading={operationStatus === UI_OPERATION_STATUS_REQUEST}
          onSubmit={onSubmit}
          {...popup.popupProps}
        />,
        document.body,
      ))}
    </div>
  );
};

export default DeleteComment;
